import React from "react";
import styled from "styled-components";
import {
  border,
  color,
  layout,
  space,
  typography,
  TypographyProps,
  SpaceProps,
  LayoutProps,
  ColorProps,
  BorderProps,
  variant,
} from "styled-system";

interface Props {
  variant?: "primary" | "outlined" | "transparent" | "accent";
  children: React.ReactNode;
}

const Wrapper = styled.button`
  ${border}
  ${color}
  ${layout}
  ${space}
  ${typography}
  cursor: pointer;
  text-decoration: none;
  &:disabled {
    opacity: 0.5;
  }
`;

export const ButtonStyled = styled(Wrapper as any)(
  variant({
    scale: "buttons",
    variants: {
      primary: {
        bg: "primary",
        color: "white",
        borderColor: "primary",
      },
      accent: {
        bg: "accent",
        color: "white",
        borderColor: "accent",
      },
      outlined: {
        color: "white",
        bg: "transparent",
        borderColor: "white",
      },
      transparent: {
        bg: "transparent",
        border: "none",
        minHeight: 0,
        minWidth: 0,
      },
    },
  }),
);

export const Button: React.FC<LayoutProps & ColorProps & BorderProps & SpaceProps & TypographyProps & Props> = ({
  minWidth,
  minHeight,
  children,
  ...props
}) => (
  <ButtonStyled
    border={border}
    borderRadius={4}
    verticalAlign="middle"
    textAlign="center"
    minWidth={minWidth}
    minHeight={minHeight}
    fontFamily="inherit"
    {...props}
  >
    {children}
  </ButtonStyled>
);

Button.defaultProps = {
  bg: "primary",
  border: "2px solid",
  minWidth: 70,
  minHeight: 30,
  textAlign: "center",
};
